import { HelpCircle } from "lucide-react";
import { useState } from "react";
import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";

export const COME_FUNZIONA = [
  {
    titolo: "Affidya collega il messaggio a una struttura",
    testo: "Quando qualcuno risponde, Affidya cerca a chi appartiene il numero. Prova, in ordine: se la persona ha risposto a un messaggio che hai inviato da Affidya; se le hai scritto negli ultimi 7 giorni; se il numero è nella scheda di una struttura (telefono o referenti), di un lead o tra i familiari di un ospite. Se il numero non viene riconosciuto puoi associarlo tu, cercando una struttura, un lead o un ospite (in quest'ultimo caso il numero diventa un suo familiare).",
  },
  {
    titolo: "Se è una struttura, Affidya legge la risposta",
    testo: "Se la struttura preme un pulsante del template (SI posto donna/uomo oppure nessuna disponibilità), Affidya aggiorna subito i posti: +1 per un SI, 0 per nessuna disponibilità. Se invece scrive a mano, l'IA propone un'interpretazione da confermare (certa solo se chiara e con confidenza almeno 80%).",
  },
  {
    titolo: "Le risposte a mano restano da confermare",
    testo: "Per i messaggi di testo libero i posti si aggiornano solo dopo «Conferma o correggi». Con «Scarta» la proposta viene chiusa e la scheda della struttura resta com'era. Le risposte dai pulsanti non compaiono in «Da confermare» perché sono già applicate.",
  },
];

export default function WhatsAppComeFunziona() {
  const [open, setOpen] = useState(false);
  return <>
    <Button size="sm" variant="outline" onClick={() => setOpen(true)}><HelpCircle className="mr-1 h-4 w-4" /> Come funziona</Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Come funzionano le risposte WhatsApp</DialogTitle>
          <DialogDescription>Cosa succede quando una struttura o una famiglia risponde a un tuo messaggio.</DialogDescription>
        </DialogHeader>
        <ol className="space-y-3">
          {COME_FUNZIONA.map((item, index) => <li key={item.titolo} className="flex gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-xs font-semibold text-white">{index + 1}</span>
            <div><p className="font-medium">{item.titolo}</p><p className="text-sm text-slate-600">{item.testo}</p></div>
          </li>)}
        </ol>
        <DialogFooter><Button onClick={() => setOpen(false)}>Ho capito</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>;
}
